module.exports = __webpack_public_path__ + "img/ssmacro.3b199e7a.png";